import { render, staticRenderFns } from "./home-own.vue?vue&type=template&id=31d6fdb0&lang=pug"
import script from "./home-own.vue?vue&type=script&lang=ts"
export * from "./home-own.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports